/**
 * Element rings used by the Investigation Workspace correlation graph.
 */

import { fetchRing } from '../core';

export const INFRASTRUCTURE_ELEMENTS_RING = 'infrastructure_elements';
export const BUSINESS_ELEMENTS_RING = 'business_elements';
export const THREAT_ELEMENTS_RING = 'threat_elements';

export interface InfrastructureElementDocument {
  _id?: string;
  name?: string;
  provider?: string;
  provider_type?: string;
  universal_type?: string;
  universal_domain?: string;
  external_id?: string;
  /** Words the owner of the asset put on it; "crown_jewel" marks one the operations cannot do without (`lib/crownJewel.ts`). */
  tags?: string[];
  links?: unknown[];
  [key: string]: unknown;
}

export interface BusinessElementDocument {
  _id?: string;
  name?: string;
  element_type?: string;
  description?: string;
  tags?: string[];
  links?: unknown[];
  infrastructure_refs?: unknown[];
  [key: string]: unknown;
}

export interface ThreatElementDocument {
  _id?: string;
  name?: string;
  element_type?: string;
  description?: string;
  status?: string;
  confidence?: string;
  /** Top-level on action elements. Consolidator writes this, not detection.threat_event_id. */
  threat_event_id?: string;
  detection?: {
    provider?: string;
    detection_classification?: string;
    detection_risk_level?: string;
    detection_status?: string;
    security_event_ids?: unknown;
    created_at?: string;
    [key: string]: unknown;
  };
  links?: unknown[];
  infrastructure_refs?: unknown[];
  business_refs?: unknown[];
  [key: string]: unknown;
}

export async function getInfrastructureElementsAll(): Promise<InfrastructureElementDocument[]> {
  const res = await fetchRing<InfrastructureElementDocument>(INFRASTRUCTURE_ELEMENTS_RING, {
    all: true,
  });
  return Array.isArray(res.items) ? res.items : [];
}

export async function getBusinessElementsAll(): Promise<BusinessElementDocument[]> {
  const res = await fetchRing<BusinessElementDocument>(BUSINESS_ELEMENTS_RING, { all: true });
  return Array.isArray(res.items) ? res.items : [];
}

export async function getThreatElementsAll(): Promise<ThreatElementDocument[]> {
  const res = await fetchRing<ThreatElementDocument>(THREAT_ELEMENTS_RING, { all: true });
  return Array.isArray(res.items) ? res.items : [];
}
